import React, { useEffect, useState } from 'react'
import CustomSelect from '../../../../Components/Common/CustomSelect'
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { setBreadcrumb, setVersionPath } from '../../../../slices/auth/menu/reducer';
import { getCreatives, getDynamicText, getFontList, openCampaign, openDisplayHtml, openDisplayImage, openFacebookSocial, setCreativeFigmaBeforePreview, setHtmlCreativesPreview, setPreviewFonts } from '../../../../slices/campaigns/thunk';
import { setActiveDynamicText, setCampaignLoader, setConnectedFeed, setCurrentVersion, setVersionDetails } from '../../../../slices/campaigns/reducer';
import { setPreloader } from '../../../../slices/layouts/reducer';
import { getFeedInfo, getPreviewWithoutAuth } from '../../../../slices/feeds/thunk';
import { getFacebookProperties } from '../../../../slices/campaigns/facebook/thunk';
import { replace } from 'redux-first-history';

function SwitchVersion() {
  const dispatch = useDispatch();

  const selectVersions = createSelector(state => state, state => ({
    versions: state.Campaign.versions,
    currentVersion: state.Campaign.currentVersion,
    currentCampaign: state.Campaign.currentCampaign,
    uploadLimits: state.Campaign.uploadLimits,
    title: state.MenuData.title
  }));
  const { versions, currentVersion, currentCampaign, uploadLimits, title } = useSelector(selectVersions);

  const [customSelectValue, setCustomSelectValue] = useState({ name: "", value: "" });
  const [versionOptions, setVersionOptions] = useState([]);

  async function handleChange(id) {
    const foundVersion = versions.find(item => item._id === id);
    if (foundVersion) {
      dispatch(setVersionPath(id));
      dispatch(setCurrentVersion(foundVersion));
      dispatch(setBreadcrumb({name: 'Ad Library', title: []}));
      await dispatch(openCampaign(currentCampaign, foundVersion));  
    }
    
  }

  useEffect(() => {
    if (currentVersion !== null) {
      setCustomSelectValue({ name: currentVersion?.name, value: currentVersion?._id });
    }
  }, [currentVersion]);

  useEffect(() => {
    const options = (versions || []).map((item, idx) => { return { name: item.name, value: item._id } });
    setVersionOptions(options);
  }, [versions]);

  // setCustomSelectValue({ name: foundVersion.name, value: foundVersion._id });

  return (
    <CustomSelect
      tag="button"
      className='btn btn-light dropdown-toggle'
      placeholder='Select Version'
      options={versionOptions}
      onChange={async (item) => await handleChange(item.value)}
      value={(customSelectValue?.name || '')}
    />
  )
}

export default SwitchVersion
